import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import Bugsnag from '@bugsnag/js';
import { registerLicense } from '@syncfusion/ej2-base';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { datadogRum } from '@datadog/browser-rum';

registerLicense(environment.syncFusionLicense);

datadogRum.init({
  applicationId: environment.datadog_appId,
  clientToken: environment.datadog_clientToken,
  site: 'us5.datadoghq.com',
  service: 'socium-hrmis',
  env: environment.production ? 'production' : 'development',
  version: '1.0.0',
  proxy: (options) =>
    `${environment.workSpaceEndpoint}/proxy/datadog${options.path}?${options.parameters}`,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

datadogRum.startSessionReplayRecording();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  Bugsnag.notify(err);
  console.error(err);
});
